import { Quota } from '../models/survey-quota.model';
import { NESTED_QUOTA_DEFAULT_GROUP_ID } from '../constants/survey-quotas.constants';
import { groupsExceedAllocation } from '../helpers/quota-allocation/quota-allocation.helper';
import { SurveyNestedQuotaKind } from './survey-nested-quota-kind';

export class SurveyNestedQuotas {
  constructor(private readonly _quotas: readonly Quota[]) {}

  public groupIds(): readonly string[] {
    return [...new Set(this._quotas.map((quota) => this._groupId(quota)))];
  }

  // Any row produced by Combine Quotas — Apply & Nest regenerates a nesting whole and would
  // destroy the merge (QuotaDrawerState.applyAndNestDisabled).
  public hasCombinedQuotas(): boolean {
    return this._quotas.some((quota) =>
      SurveyNestedQuotaKind.isCombined(quota),
    );
  }

  public withGroup(groupId: string): readonly Quota[] {
    return this._quotas.filter((quota) => this._groupId(quota) === groupId);
  }

  public hasGroupExceedingAllocation(totalAllocation: number): boolean {
    return groupsExceedAllocation(
      this.groupIds().map((groupId) => this.withGroup(groupId)),
      totalAllocation,
    );
  }

  private _groupId(quota: Quota): string {
    return quota.groupKey || NESTED_QUOTA_DEFAULT_GROUP_ID;
  }
}
